module.exports = __webpack_public_path__ + "static/media/A5aug.e345bef1.wav";